var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"property--rev"},[_vm._v("\n\t"+_vm._s(_vm.t('contacts', 'Last modified'))+" "+_vm._s(_vm.relativeDate)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }